import { apiAction } from 'apa/actions'
import * as types from 'catalog/actions/types'
import {fetchMeasureList} from 'catalog/actions/measures'

export const fetchCheckpointList = () => (dispatch, getState) => {
  const activeSubcategory = getState().categories.activeSubcategory
  dispatch({
    type: types.FETCH_CHECKPOINTS
  })
  dispatch(apiAction({
    url: `/api/checkpoints/${activeSubcategory.id}/retrieve_by_category/`,
    onSuccess: (checkpointList) => ({
      type: types.FETCH_CHECKPOINTS_SUCCESS,
      payload: {
        checkpointList: checkpointList
      }
    }),
    onError: (errors) => ({
      type: types.FETCH_CHECKPOINTS_ERROR,
      payload: errors
    })
  }))
}

export const updateCheckpoint = (checkpoint) => (dispatch, getState) => {
  const activeSubcategory = getState().categories.activeSubcategory
  dispatch(apiAction({
    url: `/api/checkpoints/${checkpoint.id}/`,
    method: 'PATCH',
    data: checkpoint,
    onSuccess: checkpoint => {
      const checkpointList = getState().categories.checkpointList
      return {
        type: types.UPDATE_CHECKPOINT,
        payload: { checkpointList: checkpointList.map(el => el.id === checkpoint.id ? checkpoint : el).filter(el => el.category === activeSubcategory.id) }
      }
    }
  }))
}

export const removeCheckpoint = (checkpoint) => (dispatch, getState) => dispatch(
  apiAction({
    url: `/api/checkpoints/${checkpoint.id}/`,
    method: 'DELETE',
    onSuccess: () => {
      const checkpointList = getState().categories.checkpointList
      return {
        type: types.DELETE_CHECKPOINT,
        payload: { checkpointList: checkpointList.filter(el => el.id !== checkpoint.id) }
      }
    }
  })
)

export const addCheckpoint = (name) => (dispatch, getState) => {
  const state = getState()
  const activeSubcategory = state.categories.activeSubcategory
  const checkpointList = state.categories.checkpointList
  dispatch(apiAction({
    url: '/api/checkpoints/',
    method: 'POST',
    data: {
      name: name,
      category: activeSubcategory.id
    },
    onSuccess: checkpoint => {
      return {
        type: types.ADD_CHECKPOINT,
        payload: {
          activeCheckpoint: checkpoint,
          checkpointList: [checkpoint, ...checkpointList]
        }
      }
    }
  }))
}

export const reorderCheckpointList = result => (dispatch, getState) => {
  const state = getState()
  const source = result.source.index;
  const destination = result.destination.index;
  const checkpointList = [...state.categories.checkpointList]
  const [removed] = checkpointList.splice(source, 1);
  checkpointList.splice(destination, 0, removed);
  dispatch({
    type: types.REORDER_CHECKPOINTS,
    payload: {
      checkpointList: checkpointList
    }
  });
  dispatch(apiAction({
    url: '/api/checkpoints/reorder/',
    method: 'POST',
    data: checkpointList.map(el => el.id),
  }))
}

export const selectCheckpoint = (checkpoint) => (dispatch, getState) => {
  const activeCheckpoint = getState().categories.activeCheckpoint
  if (!!activeCheckpoint && checkpoint.id === activeCheckpoint.id) {
    dispatch({type: types.DESELECT_CHECKPOINT})
  } else {
    dispatch({type: types.DESELECT_CHECKPOINT})
    dispatch({
      type: types.SELECT_CHECKPOINT,
      payload: {
        activeCheckpoint: checkpoint,
      }
    })
    dispatch(fetchMeasureList(checkpoint.id))
  }
}
